import { APP_INFO } from '@ricoh/ria.client.core/constants/core/app';
import createBrowserStorage from '@ricoh/ria.client.core/plugins/storage/browser';

import type { SourceSettingsState } from './_state.type';

const scannerStore = createBrowserStorage<string>('local', APP_INFO.WEB.STORAGE.NAME, APP_INFO.WEB.STORAGE.STORE.PROCESS.SOURCE_SETTINGS.SCANNER);

/** SourceSettings State. */
export const sourceSettingsState: SourceSettingsState = {
  sourceSettings: {
    scannerData: [],
    scanner: scannerStore.get() ?? '',

    profiles: {
      allowChanges: false,
      scanning: {
        name: '',
        options: {
          profile: {
            colorType: 'color',
            imageEnhanceType: ['deskew'],
          },
          general: {
            showUI: false,
            resolution: 300,
            sides: 'singleSided',
          },
        },
      },
      separation: {
        name: '',
        separationOptions: {
          $is: 'manual',
        },
        classificationOptions: {
          $is: 'ai',
          useAI: false,
        },
      },
      batchOptions: [],
      documentOptions: [],
      isAIConfigured: false,
    },
  },
};
